import Fire_Base  from '../../Config/Fire_base'

 const  RegisterController =   async (state) => {
    let status = {}
    let FireAuth = Fire_Base.auth()

    await  FireAuth.createUserWithEmailAndPassword(state.email,state.password)
    .then(res=>{
        setToDatabase(res.user.uid,state)
        let user = FireAuth.currentUser
        user.updateProfile({
            displayName:state.name
        }).then(()=>console.log(FireAuth.currentUser))
        status = res
    })
    .catch(error => {
        status =error        
    })
    
    return status
}

const setToDatabase =  (get_Uuid,state) => {
    let uuid=get_Uuid
    let userCollection =  Fire_Base.firestore().collection("users")
    userCollection.doc(uuid).set({
        birthDate:state.birthDate,
        gender:state.gender,
        SetOnline:false,
        stats,
        timeStamp,
        details
    }).then(res=> console.log(res)).catch(error=> console.log(error))
}

const stats = {
    activity:0,
    projects:0,
    festivalWin:0,
    absent:0
}

const timeStamp = {
    createdAt: new Date(),
    upadateAt: new Date()
}
const details = {
    role:0,
    namaPanggilan:null,
    agama:null,
    alamat:null,
    noTelp:null,
    noHp:null,
    status:null,
    namaInstitusi:null,
    pengalamanOrganisasi:null,
    komunitasYangDiikuti:null,
    hobby:null,
    citaCita:null,
    keahlian:null,
    penghargaan:null,
    peminatan:null,
    tauFpjDari:null,
    alasanGabung:null
}

export default RegisterController
